import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

import "chartkick/chart.js"

import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

import "@37signals/lexxy"
import "@rails/actiontext"

// Custom Turbo Stream action to redirect the full page
// Used for modal forms that need to navigate away on success
Turbo.StreamActions.redirect = function() {
  const url = this.getAttribute("target")
  Turbo.visit(url)
}

// Animate elements inserted via Turbo Streams
document.addEventListener("turbo:before-stream-render", (event) => {
  const action = event.target.getAttribute("action")
  if (action === "prepend" || action === "append") {
    const template = event.target.querySelector("template")
    if (template && template.content.firstElementChild) {
      template.content.firstElementChild.classList.add("animate-fade-in")
    }
  }
})
